module.exports = __webpack_public_path__ + "img/topbg.b3731dc.jpg";